module.exports = __webpack_public_path__ + "img/img_slide_6.ade2bfa9.webp";